import React from 'react';

interface Props {
  title: string;
  currentPeriod: string;
  previousPeriod: string;
  currentRows: Record<string, string>[];
  previousRows: Record<string, string>[];
}

const periodLabel = (period: string): string => `${period.slice(4, 6)}월`;

/**
 * "워터마크 해제 신청 부서 TOP5" 전용 렌더러 (IPT-441 후속 확인, 2026-09-15).
 * 요구사항 문서의 "홀딩스 DLP와 동일하게 지난달 데이터가 확인되어야 한다"는
 * 이번달·전월 TOP5를 나란히 보여주는 것이었다(Confluence 첨부 스크린샷 확인).
 */
export const SteelDeptTop5MonthCompare: React.FC<Props> = ({
  title,
  currentPeriod,
  previousPeriod,
  currentRows,
  previousRows,
}) => {
  const rowCount = Math.max(currentRows.length, previousRows.length);

  return (
    <div className="steel-dept-top5-compare" style={{ marginBottom: '1.5rem' }}>
      <h3>{title}</h3>
      {rowCount === 0 ? (
        <div style={{ textAlign: 'center', padding: '1rem' }}>데이터가 없습니다.</div>
      ) : (
        <table className="policy-table">
          <thead>
            <tr>
              <th colSpan={2}>{periodLabel(currentPeriod)}</th>
              <th colSpan={2}>{periodLabel(previousPeriod)}</th>
            </tr>
            <tr>
              <th>부서</th>
              <th>출력 수</th>
              <th>부서</th>
              <th>출력 수</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rowCount }).map((_, i) => {
              const cur = currentRows[i];
              const prev = previousRows[i];
              return (
                <tr key={i}>
                  <td>{cur?.['부서'] ?? ''}</td>
                  <td>{cur?.['출력건수'] ?? ''}</td>
                  <td>{prev?.['부서'] ?? ''}</td>
                  <td>{prev?.['출력건수'] ?? ''}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};
